export enum BalanceSide {
  Customer = 'customer', // debtor / receivables
  Supplier = 'supplier', // creditor / payables
}
